import SearchDate from "@kiwicom/frontend-common/records/SearchDate"
import { DATE_MODES } from "@kiwicom/frontend-common/consts/date"
import { FORM_FIELDS } from "@kiwicom/frontend-common/consts/form"

function datePairCorrector(raw, direction) {
  let data = raw
  if (direction !== "outboundDate" && direction !== "inboundDate") {
    return data // direction not a date
  }
  if (!data.get("outboundDate").from || !data.get("inboundDate").from) {
    return data // nothing to correct
  }
  if (!data.getIn(["outboundDate", "final"]) || !data.getIn(["inboundDate", "final"])) {
    return data //
  }
  if (
    data.getIn(["outboundDate", "mode"]) === "anytime" ||
    data.getIn(["inboundDate", "mode"]) === "anytime"
  ) {
    return data //
  }
  if (
    data.getIn(["outboundDate", "mode"]) === "noReturn" ||
    data.getIn(["inboundDate", "mode"]) === "noReturn"
  ) {
    return data //
  }
  if (data.getIn(["inboundDate", "mode"]) === "timeToStay") {
    return data
  }

  const crossedFrom = data.outboundDate.from > data.inboundDate.from
  const crossedTo = data.outboundDate.to > data.inboundDate.to

  if (crossedFrom || crossedTo) {
    if (direction === FORM_FIELDS.OUTBOUND_DATE) {
      data = data.set(FORM_FIELDS.INBOUND_DATE, new SearchDate({ mode: DATE_MODES.TIME_TO_STAY }))
    } else {
      // direction is inboundDate
      const oppositeDirection = FORM_FIELDS.OUTBOUND_DATE
      const newPlain = {
        from: data.get(oppositeDirection).from,
        to: data.get(oppositeDirection).to,
      }
      if (crossedFrom) {
        newPlain.from = data.get(direction).from
      }
      if (crossedTo) {
        newPlain.to = data.get(direction).to
      }
      data = data.set(oppositeDirection, new SearchDate(newPlain))
    }
  }

  return data
}

export default datePairCorrector
